<template>
  <section>
    <div class="table-responsive">
      <table class="table w-full table-data min-w-table">
        <thead>
          <tr>
            <th v-text="'First name'" />
            <th v-text="'Last name'" />
            <th v-text="'Email'" />
            <th v-text="'Groups'" />
            <th v-text="'Status'" />
            <th v-text="'Edit'" />
          </tr>
        </thead>
        <tbody v-if="memberships.length">
          <tr
            is="Row"
            v-for="membership in memberships"
            :key="membership.uuid"
            :membership="membership"
          />
        </tbody>
        <tbody v-else>
          <tr>
            <td
              class="text-center"
              colspan="5"
              v-text="'No results'"
            />
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script type="text/babel">
import Row from 'Membership/Resources/assets/js/components/MembershipRow'

export default {
  name: 'MembershipsTableView',
  components: {
    Row,
  },
  props: {
    memberships: {
      type: Array,
      required: true,
    },
  },
}
</script>
